import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={reduce ? false : { opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: "easeOut", delay }}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const Label = ({ children, className = "" }) => (
  <p className={`text-xs tracking-[0.2em] uppercase font-semibold text-euca ${className}`}>
    {children}
  </p>
);
